import React from 'react';

function v3WebUrl() {
  const raw = process.env.REACT_APP_V3_WEB_URL;
  if (!raw || !String(raw).trim()) return '';
  return String(raw)
    .replace(/^['"]|['"]$/g, '')
    .trim();
}

export default function SunsetNotice({ variant = 'login' }) {
  const url = v3WebUrl();
  const year = new Date().getFullYear();
  const rootClass =
    variant === 'header'
      ? 'sunset-notice sunset-notice--header'
      : 'sunset-notice sunset-notice--login';

  return (
    <div className={rootClass} role="region" aria-label="Platform retirement notice">
      {variant === 'header' ? (
        <p className="sunset-notice__text">
          This platform will be discontinued by June&nbsp;30,&nbsp;{year}. Please use the{' '}
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              new application
            </a>
          ) : (
            'new application'
          )}
          —sign in with your existing Terrace Metrics username and password.
        </p>
      ) : (
        <p className="sunset-notice__text">
          <strong>Service update:</strong> This platform will be discontinued by June&nbsp;30,&nbsp;{year}.
          Please sign in to the{' '}
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              new Terrace Metrics application
            </a>
          ) : (
            'new Terrace Metrics application'
          )}{' '}
          for continued access. Use the same username and password you use here.
        </p>
      )}
    </div>
  );
}
